import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mt-6 flex gap-10 p-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_button = _resolveComponent("the-button")!
  const _component_modal_component = _resolveComponent("modal-component")!

  return (_openBlock(), _createBlock(_component_modal_component, {
    "is-displayed": _ctx.isApplyConfirmationModalOpened,
    "no-padding": true,
    title: "Apply work order",
    onToggleModal: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('toggle-modal')))
  }, {
    default: _withCtx(() => [
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "mt-4 space-y-6 px-6 text-center" }, [
        _createElementVNode("h4", { class: "font-bold" }, "Work order apply confirmation"),
        _createElementVNode("p", null, [
          _createTextVNode(" You are about to apply a work order. This action cannot be undone. "),
          _createElementVNode("br"),
          _createTextVNode(" Are you sure you want to proceed? ")
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_the_button, {
          "is-disabled": _ctx.isSubmitLoading,
          size: "full",
          text: "Cancel",
          variant: "outline",
          onExecuteMethod: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('toggle-modal')))
        }, null, 8, ["is-disabled"]),
        _createVNode(_component_the_button, {
          "is-loading": _ctx.isSubmitLoading,
          size: "full",
          text: "Apply work order!",
          onExecuteMethod: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('apply-work-order', _ctx.workOrderId)))
        }, null, 8, ["is-loading"])
      ])
    ]),
    _: 1
  }, 8, ["is-displayed"]))
}